import type { ScreenName } from '@/types/navigation';
import { HeartbeatRequestActivityEnum } from '@/services/generated/Api';

/**
 * Maps the current navigation screen to a presence activity. Works in both
 * runtimes — `getCurrentScreen()` resolves from the TMA reducer stack or the
 * web URL. Screens without a dedicated activity fall back to "browsing".
 */
const SCREEN_ACTIVITY: Partial<Record<ScreenName, HeartbeatRequestActivityEnum>> = {
  // Cases — viewing the catalogue vs actively spinning a case
  cases: HeartbeatRequestActivityEnum.ViewingCases,
  'case-details': HeartbeatRequestActivityEnum.ViewingCases,
  'case-item': HeartbeatRequestActivityEnum.ViewingCases,
  'case-roulette': HeartbeatRequestActivityEnum.OpeningCase,

  upgrade: HeartbeatRequestActivityEnum.Upgrades,
  contracts: HeartbeatRequestActivityEnum.Contracts,

  // Case battles
  'case-battles': HeartbeatRequestActivityEnum.CaseBattles,
  'case-battle-create': HeartbeatRequestActivityEnum.CaseBattles,
  'case-battle-details': HeartbeatRequestActivityEnum.CaseBattles,
  'case-battle-history': HeartbeatRequestActivityEnum.CaseBattles,

  // Shop
  shop: HeartbeatRequestActivityEnum.Shop,
  'shop-skins': HeartbeatRequestActivityEnum.Shop,
  'shop-items': HeartbeatRequestActivityEnum.Shop,
  'shop-item': HeartbeatRequestActivityEnum.Shop,

  // Inventory
  inventory: HeartbeatRequestActivityEnum.Inventory,
  'inventory-item': HeartbeatRequestActivityEnum.Inventory,
  'send-item': HeartbeatRequestActivityEnum.Inventory,

  // Top-up flow only — the `balance` screen is the home screen (maps to `/`),
  // so it stays "browsing"; top-up is the packages/payment screens.
  packages: HeartbeatRequestActivityEnum.Topup,
  payment: HeartbeatRequestActivityEnum.Topup,

  // Auctions
  auctions: HeartbeatRequestActivityEnum.Auctions,
  'auction-details': HeartbeatRequestActivityEnum.Auctions,

  // Wheel of fortune
  wheel: HeartbeatRequestActivityEnum.Wheel,

  // Giveaways
  'giveaway-details': HeartbeatRequestActivityEnum.Giveaway,
  'daily-giveaway-details': HeartbeatRequestActivityEnum.Giveaway,
  'daily-giveaway-details-winners': HeartbeatRequestActivityEnum.Giveaway,
};

export function screenToActivity(screen: ScreenName): HeartbeatRequestActivityEnum {
  return SCREEN_ACTIVITY[screen] ?? HeartbeatRequestActivityEnum.Browsing;
}
